import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import AnimatedBackground from "./components/AnimatedBackground";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Plans from "./pages/Plans";
import Projects from "./pages/Projects";
import Tools from "./pages/Tools";
import Resources from "./pages/Resources";
import Contact from "./pages/Contact";
import Appointment from "./pages/Appointment";
import CRM from "./pages/CRM";
import { initializeMockData } from "./data/mockData";

// Layout wrapper to conditionally show Navigation and Footer
const Layout = ({ children }) => {
  const location = useLocation();
  const isCRM = location.pathname.startsWith('/crm');
  
  if (isCRM) {
    return <>{children}</>;
  }
  
  return (
    <>
      <AnimatedBackground />
      <Navigation />
      <main className="relative z-10">
        {children}
      </main>
      <Footer />
    </>
  );
};

function App() {
  useEffect(() => {
    // Initialize mock data in localStorage
    initializeMockData();
  }, []);

  return (
    <div className="App relative min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/plans" element={<Plans />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/tools" element={<Tools />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/rdv" element={<Appointment />} />
            <Route path="/crm/*" element={<CRM />} />
          </Routes>
        </Layout>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;